import { computed, reactive, toRef } from "vue";

import type { Size } from "@/lib/components/types";

import { size } from "@/lib/components/logic/atoms/input/props";
import { propsDefinition } from "@/lib/composables/componentComposable";

type UseDescriptionScoped = {
  description?: string;
  size?: Size;
};

type UseDescriptionProps = UseDescriptionScoped & {
  descriptionId?: string;
};

const scoped = propsDefinition({
  description: { type: String, required: false },
  size,
}) satisfies Record<keyof UseDescriptionScoped, unknown>;

const props = propsDefinition({
  ...scoped,
  descriptionId: { type: String, required: false },
}) satisfies Record<keyof UseDescriptionProps, unknown>;

function use(props: UseDescriptionProps) {
  return {
    description: toRef(() => props.description),
    containerProps: reactive({
      size: toRef(() => props.size),
      id: toRef(() => props.descriptionId),
    }),
  };
}

function vIf(props: Pick<UseDescriptionProps, "description">) {
  return computed(() => !!props.description);
}

export type { UseDescriptionProps, UseDescriptionScoped };
export { props, scoped, use, vIf };
